export default "__VITE_ASSET__2361db90__"